import React, { FC } from 'react';
import cls from 'classnames';

import { HeaderBodyProps } from './HeaderBody.types';

const HeaderBody: FC<HeaderBodyProps> = (props) => {
	const { header, headerTag = 'h1', body, className } = props;
	const HeaderComponent = headerTag;

	return (
		<div className={cls('header-body', className)}>
			<HeaderComponent>{header}</HeaderComponent>
			<p>{body}</p>
		</div>
	);
};

HeaderBody.displayName = 'HeaderBody';

export default HeaderBody;
